/* eslint-disable camelcase */
import React from 'react';
import SuccessStoryDto from './SuccessStoryDto';
import Tag from './Tag';
import StepsDesktop from './StepsDesktop';
import StepsMobile from './StepsMobile';
import SuccessStoryImage from './SuccessStoryImage';

interface SuccessStoryProps {
    data: SuccessStoryDto;
}

interface SuccessStoryState {
    currentStep: number;
}

export default class SuccessStory extends React.Component<SuccessStoryProps, SuccessStoryState> {
    constructor(props: SuccessStoryProps) {
        super(props);
        this.state = {
            currentStep: 0,
        };
        this.setCurrentStep = this.setCurrentStep.bind(this);
        this.prefetchImages();
    }

    render() {
        const { headline, headline_type, body, tags, steps, is_dark } = this.props.data;
        const { currentStep } = this.state;
        const step = steps[currentStep]!;
        const wrapperClassName = ['success-story-application-wrapper', is_dark ? ' is-dark' : ''].join('');
        const CustomHeadingTag = headline_type as keyof JSX.IntrinsicElements;

        return (
            <div className={wrapperClassName}>
                <div className="success-story-application">
                    <div className="container">
                        <SuccessStoryImage
                            image={step.background_image}
                            className="success-story-application__background is-desktop-only"
                        />
                        <div className="success-story-application__content">
                            {headline_type ? (
                                <CustomHeadingTag className="success-story-application__headline h2 mb-1 mb-1.5@desktop">
                                    {headline}
                                </CustomHeadingTag>
                            ) : (
                                <h2 className="success-story-application__headline h2 mb-1 mb-1.5@desktop">
                                    {headline}
                                </h2>
                            )}
                            {tags.length > 0 && (
                                <div className="success-story-application__tags icon-tags">
                                    {tags.map((tag, index) => (
                                        <Tag key={index} {...tag} />
                                    ))}
                                </div>
                            )}
                            {body && <p className="success-story-application__body body-copy">{body}</p>}
                            <SuccessStoryImage
                                image={step.background_image}
                                className="success-story-application__mobile-image is-mobile-only"
                            />
                            <StepsDesktop
                                steps={steps}
                                currentStep={currentStep}
                                setCurrentStep={this.setCurrentStep}
                            />
                            <StepsMobile steps={steps} currentStep={currentStep} setCurrentStep={this.setCurrentStep} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    setCurrentStep(step: number): void {
        this.setState({ currentStep: step });
    }

    /**
     * Adds <link rel="prefetch" href="background_image.src"> to document's head
     * so images (other then currently active one), are prefetched by the
     * browsers that support it so when user switches to next image he can see a
     * nice animation, and we do not have to load all images at the start,
     * which could slowdown first image download
     */
    prefetchImages() {
        setTimeout(() => {
            this.props.data.steps.forEach((step) => {
                const { background_image } = step;
                if (background_image.src) {
                    const link = document.createElement('link');
                    link.rel = 'prefetch';
                    link.href = background_image.src;
                    document.head.appendChild(link);
                }
            });
        });
    }
}
